import { getHondaExpApiUrl, getHondaExpApiHeaders } from '@honda-canada/js-utilities/lib/hondaExpApi';
import { useAppSelector } from '../utils';
import { selectVehicleByTrim, selectModelCodesAndColorCodesByModelKey } from '../reducers/vehicles';
import { useLanguage } from '../../utils/sitecoreContext';
import { selectCurrentVehicle } from '../reducers/currentVehicle';
import { selectDealer } from '../reducers/dealer';
import useSotHondaExpApiConfig from '../../utils/sitecoreContext/useSotHondaExpApiConfig';
import { useGetModelInventoryStatusQuery, InventoryAvailabilityStatus } from '../apis/inventoryApi';
export const DEALER_INVENTORY_ENDPOINT = 'inventory';
export const DEFAULT_INVENTORY_STATUSES = `${InventoryAvailabilityStatus.inStock},${InventoryAvailabilityStatus.onItsWay}`;
export const getQueryParamStr = (payload) => {
    if (!payload)
        return '';
    return Array.isArray(payload) ? payload.join() : payload;
};
export const useGetCommonPayload = () => {
    const config = useSotHondaExpApiConfig();
    const language = useLanguage();
    const { env, consumerId, consumerName } = config;
    const headers = getHondaExpApiHeaders({ consumerName, consumerId, language });
    const url = getHondaExpApiUrl({
        env,
        consumerName,
    });
    const { dealerCode = '' } = useAppSelector(selectDealer);
    return { url, headers, dealerCode };
};
export const useGetFetchInventoryStatusPayload = () => {
    const { url, headers, dealerCode } = useGetCommonPayload();
    const { modelCodes, colorCodes } = useAppSelector(selectModelCodesAndColorCodesByModelKey);
    const params = {
        dealerCodes: getQueryParamStr(dealerCode),
        modelCodes: getQueryParamStr(modelCodes),
        extColors: getQueryParamStr(colorCodes),
        statuses: getQueryParamStr(DEFAULT_INVENTORY_STATUSES),
    };
    return {
        url,
        headers,
        params,
    };
};
const useFetchInventoryStatus = (shouldFetch = true, options) => {
    const { url, headers, params } = useGetFetchInventoryStatusPayload();
    return useGetModelInventoryStatusQuery({
        url: `${url}/${DEALER_INVENTORY_ENDPOINT}`,
        headers,
        params,
        shouldResetStatus: options === null || options === void 0 ? void 0 : options.shouldResetStatus,
    }, {
        skip: !shouldFetch || !params.dealerCodes || !params.modelCodes || !params.extColors || !url,
        refetchOnMountOrArgChange: options === null || options === void 0 ? void 0 : options.refetchOnMountOrArgChange,
    });
};
/**
 * Get inventory status for current vehicle
 * When no trimKey is available, use default trim as fallback
 */
export const useCurrentVehicleDealerInventoryStatus = (shouldFetch = true) => {
    var _a, _b, _c, _d, _e;
    const { transmissionKey, exteriorColorKey, interiorColorKey, trimKey, inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const trim = useAppSelector(state => selectVehicleByTrim(state, trimKey));
    const transmission = (_a = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _a === void 0 ? void 0 : _a.find(t => (t === null || t === void 0 ? void 0 : t.transmissionKey) === (transmissionKey || (trim === null || trim === void 0 ? void 0 : trim.defaultTransmission)));
    const extColor = (_b = transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColors) === null || _b === void 0 ? void 0 : _b.find(color => (color === null || color === void 0 ? void 0 : color.key) === (exteriorColorKey || (transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColorKey)));
    const intColor = (_c = extColor === null || extColor === void 0 ? void 0 : extColor.interiorColors) === null || _c === void 0 ? void 0 : _c.find(color => (color === null || color === void 0 ? void 0 : color.key) === (interiorColorKey || (extColor === null || extColor === void 0 ? void 0 : extColor.defaultInteriorColor)));
    const { url, headers, dealerCode } = useGetCommonPayload();
    const params = {
        dealerCodes: getQueryParamStr(dealerCode),
        modelCodes: getQueryParamStr(transmission === null || transmission === void 0 ? void 0 : transmission.modelCode),
        extColors: getQueryParamStr(intColor === null || intColor === void 0 ? void 0 : intColor.colorCode),
        statuses: getQueryParamStr(DEFAULT_INVENTORY_STATUSES),
    };
    const dealerInventory = useGetModelInventoryStatusQuery({
        url: `${url}/${DEALER_INVENTORY_ENDPOINT}`,
        headers,
        params,
    }, {
        skip: !shouldFetch || !params.dealerCodes || !params.modelCodes || !url,
    });
    return {
        ...dealerInventory,
        data: dealerInventory.data && dealerInventory.data.length > 0
            ? (_e = (_d = dealerInventory.data[0]) === null || _d === void 0 ? void 0 : _d.inventory.find(inventory => inventory.status === inventoryStatus)) === null || _e === void 0 ? void 0 : _e.status
            : undefined,
    };
};
export default useFetchInventoryStatus;
